module.exports = __webpack_public_path__ + "static/Maldives-logo-2b2ea991475685fa890444372465a375.png";